import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';

import PurchaseImage from '../../../containers/purchase-image.container';
import PBGUserAgreement from '../pbg-user-agreement';
import TermsAndConditions from '../terms-and-conditions-link';
import MultiCurrencyNotice from './../../containers/multi-currency-notice.container';
import pbgLogoBlue from '../../img/keytravel-logo-blue.png';
import { MEDIUM_FOUR_THIRD } from '../../lib/image-versions';
import { format } from '../../lib/money';
import Purchase from '../../lib/purchase';

class MakePurchaseSummary extends Component {
  buttonCopy() {
    const { purchase } = this.props;
    if (Purchase.isSinglePayment(purchase.payments) || Purchase.isCurrentPaymentLastPayment(purchase)) {
      return (
        <FormattedMessage
          id="makePurchase.summary.button.complete"
          defaultMessage="Complete purchase"
        />
      );
    }
    return <FormattedMessage
      id="makePurchase.summary.button.makePayment"
      defaultMessage="Make payment"
    />
  }

  isSubmitting() {
    return this.props.submitting;
  }

  renderLegalDocumentsLink() {
    if (!this.props.legalDocuments.length) {
      return null;
    }
    const { purchase: { merchant } } = this.props;
    return (
      <FormattedMessage
        id="makePurchase.summary.merchantTos"
        defaultMessage=" and {merchant} {tos}"
        values={{
          merchant: merchant.displayName,
          tos: <TermsAndConditions legalDocuments={this.props.legalDocuments}/>
        }}
      />
    );
  }

  renderTermsAndConditions() {
    return (
      <p className="small-print mt-2">
        <FormattedMessage
          id="makePurchase.summary.acceptUserAgreement"
          defaultMessage="By clicking above you confirm that you accept the {ua}"
          values={{ ua: <PBGUserAgreement /> }}
        />
      </p>
    );
  }

  renderBrandLogo() {
    const { merchant } = this.props.purchase;
    const imageSource = get(merchant, 'logoUrl', pbgLogoBlue);
    const imageAlt = get(merchant, 'displayName', 'Key Travel');
    return (
      <div className="merchant-brand-logo text-center">
        <img src={imageSource} alt={imageAlt} className="brand-logo mb-2" />
      </div>
    );
  }

  render() {
    const { purchase, purchase: { merchant } } = this.props;
    const payment = Purchase.getCurrentOrLastPayment(purchase);

    return (
      <div className="card">
        {this.renderBrandLogo()}
        <PurchaseImage
          className="rounded img-fluid"
          version={MEDIUM_FOUR_THIRD}
        />
        <p className="text-center mt-4">
          <FormattedMessage
            id="makePurchase.summary.total"
            defaultMessage="Total to be paid to {merchant} by the group"
            values={{
              merchant: merchant.displayName,
            }}
          />
        </p>
        <h2 className="text-center mb-4">
          {format(payment.amount)}
          {' '}
          <span className="small-print">{payment.amount.currencyCode.toUpperCase()}</span>
        </h2>
        <MultiCurrencyNotice />
        <button type="submit" className="btn btn-primary" disabled={this.isSubmitting()}>
          {this.buttonCopy()}
        </button>
        {this.renderTermsAndConditions()}
      </div>
    );
  }
}

MakePurchaseSummary.defaultProps = {
  purchase: null,
  legalDocuments: [],
  submitting: false,
};

export default MakePurchaseSummary;



// WEBPACK FOOTER //
// ./src/desktop/components/make-purchase/make-purchase-summary.js